export default __webpack_public_path__ + "static/media/childDevelopment-blob1.c83a7f6f.svg";